<template>
  <div>
    <section class="bgBox" id="bgBox" v-if="!showurl">
      <div id="part1" class="bgBoxNew">
        <img class="titleImg" src="https://mp.yijugongshe.com/upload/baogao/titleImg.png" alt="" />
        <div class="moudle">
          <div class="titleBox font-size-48 font-blod mb-32">
            <div class="name">Hi,{{ userInfo.Name }}</div>
            <div class="underline"></div>
          </div>
          <div class="contentBox flex flex-row items-center mb-32">
            <div class="contentItem">
              <div class="mr-24 font-size-32">生日</div>
              <div class="font-size-32 color-333">
                {{ userInfo.BirthdayStr }}
              </div>
            </div>
            <div class="contentItem">
              <div class="mr-24 font-size-32">手机</div>
              <div class="font-size-32 color-333">{{ userInfo.Mobile }}</div>
            </div>
          </div>
          <div class="contentBox flex flex-row items-center mb-32">
            <div class="contentItem">
              <div class="mr-24 font-size-32">形象顾问</div>
              <div class="font-size-32 color-333">
                {{ userInfo.Consultant }}
              </div>
            </div>
            <div class="contentItem">
              <div class="mr-24 font-size-32">会员等级</div>
              <div class="font-size-32 color-333">
                {{ userInfo.UserRIdDesc }}
              </div>
            </div>
          </div>
          <div class="contentBox flex flex-row items-center mb-32">
            <div class="contentItem">
              <div class="mr-24 font-size-32">职业</div>
              <div class="font-size-32 color-333">{{ userInfo.Creer }}</div>
            </div>
            <div class="contentItem">
              <div class="mr-24 font-size-32">职务</div>
              <div class="font-size-32 color-333">
                {{ userInfo.Position }}
              </div>
            </div>
          </div>
          <!-- <div class="gimgBox mt-32">
          <img
            class="gimg"
            src="https://mp.yijugongshe.com/upload/baogao/gimg.jpg"
            alt=""
          />
          <img
            class="gimg"
            src="https://mp.yijugongshe.com/upload/baogao/gimg.jpg"
            alt=""
          />
        </div> -->
        </div>
      </div>
      <div id="part2" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 0">
          <div class="titleBox font-size-48 font-blod mb-32">
            <div class="font-size-32 font-blod relative z-index-2">
              {{ item.Title }}
            </div>
            <div class="underline"></div>
          </div>
          <div class="analyzeBox" v-for="(innerItem, innerIndex) in item.Children">
            <div class="flex flex-row items-center mb-18">
              {{ innerItem.Title }}是
              <div style="color: #45bafc">{{ innerItem.Remark }}</div>
            </div>
            <div class="conical-triangleBox">
              <svg t="1718272272333" class="icon conical-triangle" style="position: absolute" :style="{
                left: Number(20 * innerIndexNext) + Number(10) + '%',
              }" viewBox="0 0 1024 1024" version="1.1" p-id="31157" width="18" height="18"
                v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                <path
                  d="M512.006343 0C229.227888 0 0 229.221545 0 512.006343c0 282.772112 229.227888 511.993657 512.006343 511.993657 282.772112 0 512-229.221545 512-511.993657C1024 229.221545 794.778455 0 512.006343 0m182.964967 618.168773L538.676973 774.469451a33.761657 33.761657 0 0 1-5.226302 4.26857c-0.837223 0.558149-1.7569 0.957733-2.644864 1.446113-1.078242 0.570834-2.0994 1.211436-3.24741 1.699816-1.12264 0.456667-2.302364 0.729399-3.46306 1.0719-0.964075 0.29176-1.915465 0.672316-2.917596 0.875278a33.679203 33.679203 0 0 1-13.376542 0c-1.021159-0.196621-1.959863-0.583519-2.961994-0.875278-1.141668-0.3425-2.296021-0.596204-3.405976-1.052872-1.179724-0.475695-2.238938-1.148011-3.34255-1.750557-0.830881-0.469352-1.718844-0.849908-2.524354-1.395372a33.571379 33.571379 0 0 1-5.238987-4.281255L334.013974 618.156087c-12.038254-12.031911-14.987563-31.389525-5.055052-45.216391a34.123185 34.123185 0 0 1 51.99663-4.376394l70.263317 70.263317c10.750706 10.744364 29.131559 3.126902 29.13156-12.063624V274.330112c0-17.004509 11.619642-32.765869 28.40216-35.499529a34.161241 34.161241 0 0 1 39.863238 33.672861v354.259551c0 15.196868 18.374511 22.81433 29.131559 12.063624l70.263317-70.250632a34.13587 34.13587 0 0 1 51.990288 4.389079c9.957881 13.826867 7.008572 33.178138-5.029681 45.203707"
                  fill="#94001a" p-id="31158"></path>
              </svg>
            </div>
            <div class="colorLineBox">
              <div class="colorLine" style="background-color: #45bafc"></div>
              <div class="colorLine" style="background-color: #8bc4e0"></div>
              <div class="colorLine" style="background-color: #bec6c6"></div>
              <div class="colorLine" style="background-color: #cf8332"></div>
              <div class="colorLine" style="background-color: #ffc093"></div>
            </div>
          </div>
          <div class="title">色彩三要素</div>
          <div id="echartsContainer" style="width: 6rem; height: 6rem; margin: 0 auto"></div>
          <div class="suggestionBox">
            <div class="mb-10 text-left" v-for="(item, index) in labelList" v-if="index == 1">
              <div v-for="(subItem, subIndex) in item.Children" v-if="subIndex == 0">
                <div v-for="(subSubItem, subSubIndex) in subItem.Children" v-if="subSubItem.IsCheck">
                  ·对比度:{{ 20 * subSubIndex }}
                </div>
              </div>
            </div>
            <div class="mb-10 text-left" v-for="(item, index) in labelList" v-if="index == 1">
              <div v-for="(subItem, subIndex) in item.Children" v-if="subIndex == 1">
                <div v-for="(subSubItem, subSubIndex) in subItem.Children" v-if="subSubItem.IsCheck">
                  ·彩度:{{ 20 * subSubIndex }}
                </div>
              </div>
            </div>
            <div class="mb-10 text-left" v-for="(item, index) in labelList" v-if="index == 1">
              <div v-for="(subItem, subIndex) in item.Children" v-if="subIndex == 2">
                <div v-for="(subSubItem, subSubIndex) in subItem.Children" v-if="subSubItem.IsCheck">
                  ·明度:{{ 20 * subSubIndex }}
                </div>
              </div>
            </div>
            <!-- 用色规律 -->
            <section id="section" class="section mt-24 pb-24" v-for="(item, index) in labelList" :key="item.Id"
              v-if="index == 1">
              <div class="cell-title">{{ item.Title }}</div>
              <div class="cell-group">
                <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="cell-item mt-32">
                  <div v-if="subindex == 3" class="w-b-wrap">
                    <img class="w-b_left" src="https://mp.yijugongshe.com/upload/backgroundimg/w-b_left_v3.png"
                      alt="" />
                    <div class="w-b_right" @click.stop="setPoint">
                      <div v-if="subitem.ImageList.length > 0" :style="{
                        top: `${subitem.ImageList[1]}px`,
                        left: `${subitem.ImageList[0]}px`,
                      }" class="w-b__circle no-click"></div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div id="part3" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 1">
          <div class="titleBox font-size-48 font-blod mb-32">
            <div class="font-size-32 font-blod relative z-index-2">
              {{ item.Title }}
            </div>
            <div class="underline"></div>
          </div>
          <div class="geBox" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex < 3">
            <div class="blackBG">{{ innerItem.Title }}</div>
            <div class="blackLineBox">
              <svg t="1718272272333" class="icon conical-triangle" style="position: absolute" :style="{
                left:
                  Number(
                    (100 / (innerItem.Children.length - 1)) * innerIndexNext
                  ) -
                  3.5 +
                  '%',
              }" viewBox="0 0 1024 1024" version="1.1" p-id="31157" width="18" height="18"
                v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                <path
                  d="M512.006343 0C229.227888 0 0 229.221545 0 512.006343c0 282.772112 229.227888 511.993657 512.006343 511.993657 282.772112 0 512-229.221545 512-511.993657C1024 229.221545 794.778455 0 512.006343 0m182.964967 618.168773L538.676973 774.469451a33.761657 33.761657 0 0 1-5.226302 4.26857c-0.837223 0.558149-1.7569 0.957733-2.644864 1.446113-1.078242 0.570834-2.0994 1.211436-3.24741 1.699816-1.12264 0.456667-2.302364 0.729399-3.46306 1.0719-0.964075 0.29176-1.915465 0.672316-2.917596 0.875278a33.679203 33.679203 0 0 1-13.376542 0c-1.021159-0.196621-1.959863-0.583519-2.961994-0.875278-1.141668-0.3425-2.296021-0.596204-3.405976-1.052872-1.179724-0.475695-2.238938-1.148011-3.34255-1.750557-0.830881-0.469352-1.718844-0.849908-2.524354-1.395372a33.571379 33.571379 0 0 1-5.238987-4.281255L334.013974 618.156087c-12.038254-12.031911-14.987563-31.389525-5.055052-45.216391a34.123185 34.123185 0 0 1 51.99663-4.376394l70.263317 70.263317c10.750706 10.744364 29.131559 3.126902 29.13156-12.063624V274.330112c0-17.004509 11.619642-32.765869 28.40216-35.499529a34.161241 34.161241 0 0 1 39.863238 33.672861v354.259551c0 15.196868 18.374511 22.81433 29.131559 12.063624l70.263317-70.250632a34.13587 34.13587 0 0 1 51.990288 4.389079c9.957881 13.826867 7.008572 33.178138-5.029681 45.203707"
                  fill="#94001a" p-id="31158"></path>
              </svg>
            </div>
            <div class="blackLineItemBox">
              <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="blackLineItem"></div>
            </div>
            <div class="blackLine"></div>
            <div class="selectBox">
              <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="selectItem" :style="{
                left:
                  Number(
                    (100 / (innerItem.Children.length - 1)) * innerIndexNext -
                    2
                  ) + '%',
              }">
                {{ innerItemNext.Title }}
              </div>
            </div>
          </div>
          <!-- <div class="sexiBox"></div>
        <div class="sheBox">你更适合S和DP系颜色</div> -->
        </div>
      </div>
      <div id="part4" class="bgBoxNew">
        <div class="moudle">
          <div class="titleBox font-size-48 font-blod mb-56">
            <div class="font-size-32 font-blod relative z-index-2">
              我的穿搭风格版
            </div>
            <div class="underline"></div>
          </div>
          <div class="banBox">
            <div class="banItem1" style="transform: translate(0px, 0px) rotate(3deg)">
              <div>
                {{ info.MySelf }}
              </div>
            </div>
            <div class="banItem2" style="transform: translate(0px, 12px) rotate(-2deg)">
              <div>
                {{ info.MySelfInOtherEye }}
              </div>
            </div>
            <div class="banItem3" style="transform: translate(0px, -1px) rotate(-6deg)">
              <div>
                {{ info.IWantToBe }}
              </div>
            </div>
            <div class="banItem4" style="transform: translate(0px, 10px) rotate(3deg)">
              <div>
                {{ info.Avantage }}
              </div>
            </div>
            <div class="banItem5" style="transform: translate(0px, 4px) rotate(8deg)">
              <div>
                {{ info.Target }}
              </div>
            </div>
            <div class="banItem6" style="transform: translate(0px, 15px) rotate(-4deg)">
              <div>
                {{ info.ExclusiveStyle }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="part5" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 2">
          <div class="titleBox font-size-48 font-blod mb-56">
            <div class="font-size-32 font-blod relative z-index-2">
              身形特征
            </div>
            <div class="underline"></div>
          </div>
          <div :class="userInfo.Gender == 1 ? 'bodyBoxN' : 'bodyBox'">
            <div class="zhiItemR" style="top: 0.0386rem; left: -1.826rem">
              头围{{ info.HeadCircumference }}cm
              <div class="zhiline">
                <div class="zline"></div>
                <div class="zQuan"></div>
              </div>
            </div>
            <div class="zhiItemR" style="top: 1.0386rem; left: -2.326rem">
              肩宽{{ info.ShoulderWidth }}cm
              <div class="zhiline">
                <div class="zline"></div>
                <div class="zQuan"></div>
              </div>
            </div>
            <div class="zhiItemR" style="top: 2.5386rem; left: -2.026rem">
              腰围{{ info.MidWaistCircumference }}cm
              <div class="zhiline">
                <div class="zline"></div>
                <div class="zQuan"></div>
              </div>
            </div>
            <div class="zhiItemR" style="top: 6.2386rem; left: -1.826rem">
              鞋码{{ info.ShoeSize }}
              <div class="zhiline">
                <div class="zline"></div>
                <div class="zQuan"></div>
              </div>
            </div>
            <div class="zhiItemL" style="top: 1.5386rem; right: -2.226rem">
              胸围{{ info.Bust }}cm
              <div class="zhilineL">
                <div class="zQuan"></div>
                <div class="zline"></div>
              </div>
            </div>
            <div class="zhiItemL" style="top: 2.85rem; right: -2.126rem">
              臀围{{ info.Hips }}cm
              <div class="zhilineL">
                <div class="zQuan"></div>
                <div class="zline"></div>
              </div>
            </div>
            <div class="zhiItemL" style="top: 3.6086rem; right: -2.126rem">
              大腿{{ info.ThighCircumference }}cm
              <div class="zhilineL">
                <div class="zQuan"></div>
                <div class="zline"></div>
              </div>
            </div>
          </div>
          <div class="xingBox" v-for="(item, index) in labelList" v-if="index == 2">
            <div v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 0">
              <div class="mb-10">你的身形为</div>
              <div class="selectX">{{ innerItem.Remark }}型</div>
            </div>
            <div class="xingTextBG" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 1">
              <div class="xingText">
                衣型方面可选
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                  {{ innerItemNext.Title }},
                </div>
                都适合的款式
              </div>
            </div>
          </div>
          <div>
            <div class="geBox" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex > 1">
              <div class="blackBG">{{ innerItem.Title }}</div>
              <div class="blackLineBox">
                <svg t="1718272272333" class="icon conical-triangle" style="position: absolute" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) * innerIndexNext
                    ) -
                    3.5 +
                    '%',
                }" viewBox="0 0 1024 1024" version="1.1" p-id="31157" width="18" height="18"
                  v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                  <path
                    d="M512.006343 0C229.227888 0 0 229.221545 0 512.006343c0 282.772112 229.227888 511.993657 512.006343 511.993657 282.772112 0 512-229.221545 512-511.993657C1024 229.221545 794.778455 0 512.006343 0m182.964967 618.168773L538.676973 774.469451a33.761657 33.761657 0 0 1-5.226302 4.26857c-0.837223 0.558149-1.7569 0.957733-2.644864 1.446113-1.078242 0.570834-2.0994 1.211436-3.24741 1.699816-1.12264 0.456667-2.302364 0.729399-3.46306 1.0719-0.964075 0.29176-1.915465 0.672316-2.917596 0.875278a33.679203 33.679203 0 0 1-13.376542 0c-1.021159-0.196621-1.959863-0.583519-2.961994-0.875278-1.141668-0.3425-2.296021-0.596204-3.405976-1.052872-1.179724-0.475695-2.238938-1.148011-3.34255-1.750557-0.830881-0.469352-1.718844-0.849908-2.524354-1.395372a33.571379 33.571379 0 0 1-5.238987-4.281255L334.013974 618.156087c-12.038254-12.031911-14.987563-31.389525-5.055052-45.216391a34.123185 34.123185 0 0 1 51.99663-4.376394l70.263317 70.263317c10.750706 10.744364 29.131559 3.126902 29.13156-12.063624V274.330112c0-17.004509 11.619642-32.765869 28.40216-35.499529a34.161241 34.161241 0 0 1 39.863238 33.672861v354.259551c0 15.196868 18.374511 22.81433 29.131559 12.063624l70.263317-70.250632a34.13587 34.13587 0 0 1 51.990288 4.389079c9.957881 13.826867 7.008572 33.178138-5.029681 45.203707"
                    fill="#94001a" p-id="31158"></path>
                </svg>
              </div>
              <div class="blackLineItemBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="blackLineItem"></div>
              </div>
              <div class="blackLine"></div>
              <div class="selectBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="selectItem" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) *
                      innerIndexNext -
                      2
                    ) + '%',
                }">
                  {{ innerItemNext.Title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="part6" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 3">
          <div class="titleBox font-size-48 font-blod mb-56">
            <div class="font-size-32 font-blod relative z-index-2">
              {{ item.Title }}
            </div>
            <div class="underline"></div>
          </div>
          <div class="huaBox" v-for="(innerItem, innerIndex) in item.Children">
            <div class="huaTit">{{ innerItem.Title }}</div>
            <div class="huaLine"></div>
            <div class="huaOutBox">
              <img v-for="(
                  innerItemNext, innerIndexNext
                ) in innerItem.LabelImageListFull" class="huaItem" :src="innerItemNext.Image"
                v-if="innerItemNext.IsCheck" />
            </div>
          </div>
        </div>
      </div>
      <div id="part7" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 4">
          <div class="titleBox font-size-48 font-blod mb-56">
            <div class="font-size-32 font-blod relative z-index-2">
              {{ item.Title }}
            </div>
            <div class="underline"></div>
          </div>
          <div class="flex flex-col" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 0">
            <div class="huiTitle">1.{{ innerItem.Title }}</div>
            <div class="guiBox flex flex-row mb-56">
              <div class="guiItem flex-col flex flex-1" v-for="(innerItemNext, innerIndexNext) in innerItem.Children">
                <div class="colorList">
                  <div class="colorLineItem" :style="{ 'background-color': innerItemLast }" v-for="(
                      innerItemLast, innerIndexLast
                    ) in innerItemNext.ImageList"></div>
                </div>
                <div class="font-size-28 color-333">
                  {{ innerItemNext.Title }}
                </div>
              </div>
            </div>
          </div>

          <div class="huiTitle">2.色彩搭配规律</div>
          <div class="flex flex-row mb-42">
            <img class="nvBan" :src="userInfo.Gender == 1
              ? 'https://mp.yijugongshe.com/upload/baogao/nanda.png'
              : 'https://mp.yijugongshe.com/upload/baogao/nvda.png'
              " alt="" />
            <div class="flex flex-row flex-1 flex-wrap" v-for="(innerItem, innerIndex) in item.Children"
              v-if="innerIndex == 1">
              <div class="daItemList" v-for="(innerItemNext, innerIndexNext) in innerItem.Children"
                v-if="innerItemNext.ImageList.length > 0">
                <div class="daItem" :style="{
                  background: innerItemLast,
                  top: -0.48 * innerIndexLast + 'rem',
                }" v-for="(
                    innerItemLast, innerIndexLast
                  ) in innerItemNext.ImageList"></div>
              </div>
            </div>
          </div>
          <div class="flex flex-row items-center font-size-28 color-333 mb-20">
            <div class="yuan"></div>
            <div>更多搭配建议</div>
          </div>
          <div class="daListBox mb-128" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 2">
            <div class="flex flex-row items-center justify-start" style="flex-basis: 33.3%"
              v-for="(innerItemNext, innerIndexNext) in innerItem.Children">
              {{ innerItemNext.Title }}
              <img class="gouIcon" src="https://mp.yijugongshe.com/upload/baogao/gouIcon.png" alt=""
                v-if="innerItemNext.IsCheck" />
            </div>
          </div>
          <div class="huiTitle">3.服装搭配</div>
          <div class="daListBox mb-128" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 3">
            <div class="flex flex-row items-center justify-start" style="flex-basis: 33.3%"
              v-for="(innerItemNext, innerIndexNext) in innerItem.Children">
              {{ innerItemNext.Title }}
              <img class="gouIcon" src="https://mp.yijugongshe.com/upload/baogao/gouIcon.png" alt=""
                v-if="innerItemNext.IsCheck" />
            </div>
          </div>
          <div class="huiTitle">4.风格</div>
          <div class="daListBox mb-128" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 4">
            <div class="flex flex-col" v-for="(innerItemNext, innerIndexNext) in innerItem.Children"
              style="width: 100%">
              <div class="flex flex-row items-center justify-center mb-30 mt-30" style="flex-basis: 100%"
                v-if="innerItemNext.IsCheck">
                {{ innerItemNext.Title }}
              </div>

              <img v-for="(
                  innerItemImg, innerIndexImg
                ) in innerItemNext.LabelImageListFull" :src="innerItemImg.Image" v-if="innerItemImg.IsCheck"
                class="fengStyle" alt="" />
            </div>
          </div>
          <div class="huiTitle">5.场合服装</div>
          <div class="daListBox mb-128" v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 5">
            <div class="flex flex-row items-center justify-start" style="flex-basis: 33.3%"
              v-for="(innerItemNext, innerIndexNext) in innerItem.Children">
              {{ innerItemNext.Title }}
              <img class="gouIcon" src="https://mp.yijugongshe.com/upload/baogao/gouIcon.png" alt=""
                v-if="innerItemNext.IsCheck" />
            </div>
          </div>
          <div class="huiTitle">6.面料特征</div>
          <div v-for="(item, index) in labelList" v-if="index == 5">
            <div class="geBox" v-for="(innerItem, innerIndex) in item.Children">
              <div class="blackBG">{{ innerItem.Title }}</div>
              <div class="blackLineBox">
                <svg t="1718272272333" class="icon conical-triangle" style="position: absolute" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) * innerIndexNext
                    ) -
                    3.5 +
                    '%',
                }" viewBox="0 0 1024 1024" version="1.1" p-id="31157" width="18" height="18"
                  v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                  <path
                    d="M512.006343 0C229.227888 0 0 229.221545 0 512.006343c0 282.772112 229.227888 511.993657 512.006343 511.993657 282.772112 0 512-229.221545 512-511.993657C1024 229.221545 794.778455 0 512.006343 0m182.964967 618.168773L538.676973 774.469451a33.761657 33.761657 0 0 1-5.226302 4.26857c-0.837223 0.558149-1.7569 0.957733-2.644864 1.446113-1.078242 0.570834-2.0994 1.211436-3.24741 1.699816-1.12264 0.456667-2.302364 0.729399-3.46306 1.0719-0.964075 0.29176-1.915465 0.672316-2.917596 0.875278a33.679203 33.679203 0 0 1-13.376542 0c-1.021159-0.196621-1.959863-0.583519-2.961994-0.875278-1.141668-0.3425-2.296021-0.596204-3.405976-1.052872-1.179724-0.475695-2.238938-1.148011-3.34255-1.750557-0.830881-0.469352-1.718844-0.849908-2.524354-1.395372a33.571379 33.571379 0 0 1-5.238987-4.281255L334.013974 618.156087c-12.038254-12.031911-14.987563-31.389525-5.055052-45.216391a34.123185 34.123185 0 0 1 51.99663-4.376394l70.263317 70.263317c10.750706 10.744364 29.131559 3.126902 29.13156-12.063624V274.330112c0-17.004509 11.619642-32.765869 28.40216-35.499529a34.161241 34.161241 0 0 1 39.863238 33.672861v354.259551c0 15.196868 18.374511 22.81433 29.131559 12.063624l70.263317-70.250632a34.13587 34.13587 0 0 1 51.990288 4.389079c9.957881 13.826867 7.008572 33.178138-5.029681 45.203707"
                    fill="#94001a" p-id="31158"></path>
                </svg>
              </div>
              <div class="blackLineItemBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="blackLineItem"></div>
              </div>
              <div class="blackLine"></div>
              <div class="selectBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="selectItem" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) *
                      innerIndexNext -
                      2
                    ) + '%',
                }">
                  {{ innerItemNext.Title }}
                </div>
              </div>
            </div>
          </div>

          <div class="huiTitle mt-128">7.图案特征</div>
          <div v-for="(item, index) in labelList" v-if="index == 6">
            <div class="geBox" v-for="(innerItem, innerIndex) in item.Children">
              <div class="blackBG">{{ innerItem.Title }}</div>
              <div class="blackLineBox">
                <svg t="1718272272333" class="icon conical-triangle" style="position: absolute" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) * innerIndexNext
                    ) -
                    3.5 +
                    '%',
                }" viewBox="0 0 1024 1024" version="1.1" p-id="31157" width="18" height="18"
                  v-for="(innerItemNext, innerIndexNext) in innerItem.Children" v-if="innerItemNext.IsCheck">
                  <path
                    d="M512.006343 0C229.227888 0 0 229.221545 0 512.006343c0 282.772112 229.227888 511.993657 512.006343 511.993657 282.772112 0 512-229.221545 512-511.993657C1024 229.221545 794.778455 0 512.006343 0m182.964967 618.168773L538.676973 774.469451a33.761657 33.761657 0 0 1-5.226302 4.26857c-0.837223 0.558149-1.7569 0.957733-2.644864 1.446113-1.078242 0.570834-2.0994 1.211436-3.24741 1.699816-1.12264 0.456667-2.302364 0.729399-3.46306 1.0719-0.964075 0.29176-1.915465 0.672316-2.917596 0.875278a33.679203 33.679203 0 0 1-13.376542 0c-1.021159-0.196621-1.959863-0.583519-2.961994-0.875278-1.141668-0.3425-2.296021-0.596204-3.405976-1.052872-1.179724-0.475695-2.238938-1.148011-3.34255-1.750557-0.830881-0.469352-1.718844-0.849908-2.524354-1.395372a33.571379 33.571379 0 0 1-5.238987-4.281255L334.013974 618.156087c-12.038254-12.031911-14.987563-31.389525-5.055052-45.216391a34.123185 34.123185 0 0 1 51.99663-4.376394l70.263317 70.263317c10.750706 10.744364 29.131559 3.126902 29.13156-12.063624V274.330112c0-17.004509 11.619642-32.765869 28.40216-35.499529a34.161241 34.161241 0 0 1 39.863238 33.672861v354.259551c0 15.196868 18.374511 22.81433 29.131559 12.063624l70.263317-70.250632a34.13587 34.13587 0 0 1 51.990288 4.389079c9.957881 13.826867 7.008572 33.178138-5.029681 45.203707"
                    fill="#94001a" p-id="31158"></path>
                </svg>
              </div>
              <div class="blackLineItemBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="blackLineItem"></div>
              </div>
              <div class="blackLine"></div>
              <div class="selectBox">
                <div v-for="(innerItemNext, innerIndexNext) in innerItem.Children" class="selectItem" :style="{
                  left:
                    Number(
                      (100 / (innerItem.Children.length - 1)) *
                      innerIndexNext -
                      2
                    ) + '%',
                }">
                  {{ innerItemNext.Title }}
                </div>
              </div>
            </div>
          </div>
          <div class="font-size-32 color-333 mt-84 mb-40">服装线条可以选择</div>
          <div class="flex flex-row justify-around mb-96" v-for="(item, index) in labelList" v-if="index == 7">
            <div class="flex-col items-center justify-center color-333 font-size-26"
              v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 0 && innerItem.IsCheck">
              <img class="xianImg" src="https://mp.yijugongshe.com/upload/baogao/zong.png" alt="" />
              <div class="mt-16">纵向</div>
            </div>
            <div class="flex-col items-center justify-center color-333 font-size-26"
              v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 1 && innerItem.IsCheck">
              <img class="xianImg" src="https://mp.yijugongshe.com/upload/baogao/heng.png" alt="" />
              <div class="mt-16">横向</div>
            </div>
            <div class="flex-col items-center justify-center color-333 font-size-26"
              v-for="(innerItem, innerIndex) in item.Children" v-if="innerIndex == 2 && innerItem.IsCheck">
              <img class="xianImg" src="https://mp.yijugongshe.com/upload/baogao/xie.png" alt="" />
              <div class="mt-16">斜向</div>
            </div>
          </div>
          <div class="flex-col font-size-28 color-333 text-left">
            <div class="font-size-48">饰品</div>
            <div>搭配</div>
          </div>
          <div class="contentText text-left">{{ info.JewelryMatching }}</div>
          <div class="flex-col font-size-28 color-333 text-left">
            <div class="font-size-48">平衡点</div>
            <div>搭配</div>
          </div>
          <div class="contentText text-left" style="background: #eaf2ff">
            {{ info.BalancePointSelection }}
          </div>
        </div>
      </div>
      <div id="part8" class="bgBoxNew">
        <div class="moudle" v-for="(item, index) in labelList" v-if="index == 8">
          <div class="gimgBox mt-32">
            <div class="gimgOut" v-for="(innerItem, innerIndex) in item.Children">
              <img class="gimg" v-if="innerItem.ImageListFull[0]" :src="innerItem.ImageListFull[0]" alt="" />
              <div class="mt-10">{{ innerItem.Title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="part9" class="bgBoxNew" v-if="false">
        <div class="moudle" v-if="serveLists.length > 0">
          <div class="zaoTitle"></div>
          <div class="zaoLine"></div>
          <div class="redBox"></div>
          <div class="recordBox" v-for="(item, index) in serveLists">
            <div class="recordOutBox">
              <div class="recordTitle">
                <div>{{ item.Date }}</div>
                <div class="font-size-24 mt-10">{{ item.Year }}</div>
              </div>
              <div class="recordText font-size-28 color-333">
                {{ item.Remark }}
              </div>
              <div class="recordImgList">
                <img v-for="item in item.ImageList" class="recordImg" :src="item" alt="" v-if="item" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div id="photo" v-if="showurl">
      <img :src="showurl" />
    </div>
    <loading v-if="isLoading"></loading>
  </div>
</template>

<script>
import Vue from "vue";
import { DatetimePicker } from "vant";
import { Uploader } from "vant";
import { ref } from "vue";
var wx = require("weixin-js-sdk");
import {
  GetUserReport,
  uploadReport,
  addReportImage,
  combinePicture,
} from "@/api/label";
var wx = require("weixin-js-sdk");
import jsPDF from "jspdf";
import canvg from "canvg";
import * as echarts from "echarts";
import loading from "../components/loading/loading.vue"; //引用文件
// const html2canvas = require("html2canvas");
// base64 转为Blob
function base64ToBlob(base64Data) {
  const dataArr = base64Data.split(","); // 根据,来分隔
  const imageType = dataArr[0].match(/:(.*?);/)[1]; // 获取文件类型。使用正则捕获 image/jpeg
  const textData = window.atob(dataArr[1]); // 使用atob() 将base64 转为文本文件
  const arrayBuffer = new ArrayBuffer(textData.length); // 创建一个二进制数据缓冲区，可以理解为一个数组
  const uint8Array = new Uint8Array(arrayBuffer); // 创建一个类型化数组对象，可以理解为上面的数组的成员，给这个对象赋值就会放到上面的数组中。
  for (let i = 0; i < textData.length; i++) {
    uint8Array[i] = textData.charCodeAt(i); // 将文本文件转为UTF-16的ASCII, 放到类型化数组对象中
  }
  return [new Blob([arrayBuffer], { type: imageType }), imageType.slice(6)]; // 返回两个值，一个Blob对象，一个图片格式（如jpeg）
}

// 转为formData
function toFormData(base64Data) {
  const [imageBlob, imageType] = base64ToBlob(base64Data); // 获取处理好的Blob 和文件类型
  const formData = new FormData();
  formData.append("file", imageBlob, `${Date.now()}.${imageType}`); // 添加到表单，传入文件名
  return formData;
}

function uploadHandle(base64Data) {
  const formData = toFormData(base64Data);
  return new Promise((resolve, reject) => {
    uploadReport(formData)
      .then((res) => {
        console.log(res, "res返回");
        resolve(res.Data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

var option;
option = {
  title: {
    text: "",
  },
  legend: {
    data: ["色彩三要素"],
    show: false,
  },
  radar: {
    shape: "circle",
    indicator: [
      { name: "对比度", max: 100 },
      { name: "彩度", max: 100 },
      { name: "明度", max: 100 },
    ],
  },
  series: [
    {
      name: "色彩三要素",
      type: "radar",
      data: [
        {
          value: [32, 65, 75],
          name: "色彩三要素",
        },
      ],
    },
  ],
};
export default {
  components: {
    loading: loading,
  },

  data() {
    return {
      id: "",
      bgImg: "",
      url: "",
      url1: "",
      url2: "",
      url3: "",
      url4: "",
      url5: "",
      url6: "",
      url7: "",
      url8: "",
      url9: "",
      jsPDF: "",
      info: "",
      labelList: [],
      userInfo: "",
      serveLists: [],
      isLoading: true,
      showurl: "",
    };
  },
  created() { },
  mounted() {
    var that = this;
    that.getInfo();
  },
  methods: {
    getInfo() {
      var that = this;
      GetUserReport({
        UserId: that.$route.query.userId,
        Gender: 0,
      }).then((res) => {
        console.log(res);
        let temp = res.Data;
        this.userInfo = temp.UserInfo;
        this.info = temp.Data;
        this.labelList = temp.List;
        this.serveLists = temp.ServeLists;
        var contrast = 0;
        var chroma = 0;
        var lightness = 0;
        //对比度
        temp.List[1].Children[0].Children.forEach(function (item, index) {
          if (item.IsCheck) {
            contrast = 20 * index;
          }
        });
        //彩度
        temp.List[1].Children[1].Children.forEach(function (item, index) {
          if (item.IsCheck) {
            chroma = 20 * index;
          }
        });
        //明度
        temp.List[1].Children[2].Children.forEach(function (item, index) {
          if (item.IsCheck) {
            lightness = 20 * index;
          }
        });
        that.$nextTick(function () {
          var chartDom = document.getElementById("echartsContainer");
          var myChart = echarts.init(chartDom);
          option.series[0].data = [
            {
              value: [contrast, chroma, lightness],
              name: "色彩三要素",
            },
          ];
          console.log(option, "option");
          myChart.setOption(option);
          that.$nextTick(function () {
            //保存图片
            that.saveImg();
          });
        });
      });
    },
    saveImg() {
      var that = this;
      setTimeout(function () {
        that.bgImg = "";
        that.nextHandle();
      }, 1500);
    },
    async nextHandle() {
      var that = this;
      //Svgdom数组
      let svgNodesToRemove = [];
      // 获取到所有的SVG得到一个数组
      let svgElements = document.body.querySelectorAll("#bgBox  svg");
      console.log(svgElements, "获取到的svg---");
      // 遍历这个数组
      svgElements.forEach(function (item) {
        console.log(item, "svg数据---");
        let children = item.childNodes;
        console.log(children, "svgElements foreach::children");
        // 处理 SVG子节点  children 透明度
        children.forEach(function (child) {
          //解决svg透明度问题
          child.style.opacity = 1;
        });
        //去除空白字符
        let svg = item.outerHTML.trim();
        // 创建一个 canvas DOM元素
        let canvas = document.createElement("canvas");
        //设置 canvas 元素的宽高
        canvas.width = item.getBoundingClientRect().width;
        canvas.height = item.getBoundingClientRect().height;
        // 将 SVG转化 成 canvas
        canvg(canvas, svg);
        //设置生成 canvas 元素的坐标  保证与原SVG坐标保持一致
        if (item.style.position) {
          console.log(item.style.position, "item.style.position");
          canvas.style.position += item.style.position;
          canvas.style.left += item.style.left;
          canvas.style.top += item.style.top;
        }
        //添加到 你需要截图的DOM节点中
        item.parentNode.appendChild(canvas);
        // 删除这个元素
        svgNodesToRemove.push(canvas);
        item.style.display = "none";
      });

      Promise.all([
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part1");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url1 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第1张可以了");
            resolve(that.url1);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part2");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url2 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第2张可以了");
            resolve(that.url2);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part3");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url3 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第3张可以了");
            resolve(that.url3);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part4");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url4 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第4张可以了");
            resolve(that.url4);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part5");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url5 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第5张可以了");
            resolve(that.url5);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part6");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url6 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第6张可以了");
            resolve(that.url6);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part7");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url7 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第7张可以了");
            resolve(that.url7);
          });
        }),
        new Promise((resolve, reject) => {
          var shareContent = document.getElementById("part8");
          html2canvas(shareContent, {
            scale: 2,
            useCORS: true,
            imageTimeout: 0,
          }).then((canvas) => {
            console.log(canvas, "canvas生成成功");
            that.url8 = uploadHandle(canvas.toDataURL());
            document.querySelectorAll("#bgBox canvas").forEach((item) => {
              item.remove();
            });
            let svgElements = document.body.querySelectorAll("#bgBox svg");
            console.log(svgElements, "隐藏svgElements后重新获取到的svg");
            svgElements.forEach(function (item) {
              item.style.display = "inline-block";
            });
            console.log("第8张可以了");
            resolve(that.url8);
          });
        }),
        // new Promise((resolve, reject) => {
        //   var shareContent = document.getElementById("part9");
        //   html2canvas(shareContent, {
        //     scale: 2,
        //     useCORS: true,
        //     imageTimeout: 0,
        //   }).then((canvas) => {
        //     console.log(canvas, "canvas生成成功");
        //     that.url9 = uploadHandle(canvas.toDataURL());
        //     document.querySelectorAll("#bgBox canvas").forEach((item) => {
        //       item.remove();
        //     });
        //     let svgElements = document.body.querySelectorAll("#bgBox svg");
        //     console.log(svgElements, "隐藏svgElements后重新获取到的svg");
        //     svgElements.forEach(function (item) {
        //       item.style.display = "inline-block";
        //     });
        //     console.log("第9张可以了");
        //     resolve(that.url9);
        //   });
        // }),
      ]).then((results) => {
        console.log(results, "results");
        var ShowImgList = results.map(function (item, index) {
          return item.ImgUrl;
        });
        addReportImage({
          UserId: that.$route.query.userId,
          ShowImgList: ShowImgList,
        }).then((res) => {
          console.log(res);
          that.isLoading = false;
          // that.showurl = res.Data.Image;
          wx.miniProgram.redirectTo({
            url: "/pages/memberCenter/report/myReport/myReport?type=2",
          });
        });
      });
    },

    // 创建一个渐变 canvas
    createGradientBackground(element) {
      return new Promise((resolve, reject) => {
        var w = element.offsetWidth;
        var h = element.offsetHeight;
        var canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext("2d");

        // 创建一个线性渐变
        var gradient = ctx.createLinearGradient(0, 0, w, h);
        gradient.addColorStop(0, "#C2FCB3"); // 渐变起始颜色
        gradient.addColorStop(1, "#EA8888"); // 渐变结束颜色

        // 填充渐变到 canvas
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, w, h);

        resolve(canvas.toDataURL());
      });
    },
  },
};
</script>

<style scoped>
.bgBoxNew {
  background-image: url("https://mp.yijugongshe.com/upload/baogao/bg.png");
  background-repeat: repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

#partTwo {
  background-image: url("https://mp.yijugongshe.com/upload/baogao/bg.png");
  background-repeat: repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

#photo {
  background-image: url("https://mp.yijugongshe.com/upload/baogao/bg.png");
  background-repeat: repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

.bgBox {
  background-image: url("https://mp.yijugongshe.com/upload/baogao/bg.png");
  background-repeat: repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  /* padding: 40px 32px; */
  font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB",
    "Heiti SC", STXihei, "Microsoft YaHei", SimHei;
}

.titleImg {
  width: 652px;
  height: 242px;
  margin: 0 auto;
}

.moudle {
  width: 686px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 24px;
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 100;
}

.titleBox {
  position: relative;
  text-align: left;
}

.name {
  position: relative;
  z-index: 2;
}

.underline {
  width: 180px;
  height: 24px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/line.png");
  background-size: 100% 100%;
  position: absolute;
  left: -6px;
  bottom: -2px;
  z-index: 1;
}

.contentItem {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: baseline;
  font-size: 32px;
  color: #666666;
}

.gimgBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.gimgOut {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.gimg {
  width: 300px;
  height: 400px;
}

.analyzeBox {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  color: #333;
}

.conical-triangleBox {
  width: 100%;
  height: 40px;
  position: relative;
}

.conical-triangle {
  position: absolute;
  left: 0;
  top: 0;
}

.colorLineBox {
  width: 632px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  border-radius: 200px;
  overflow: hidden;
}

.colorLine {
  display: flex;
  flex: 1;
  height: 24px;
}

.colorJian {
  display: flex;
  flex: 1;
  height: 24px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/lingBG.jpg");
  background-size: 100% 100%;
}

.title {
  font-size: 28px;
  color: #333;
  margin-top: 64px;
  margin-bottom: 32px;
  text-align: center;
}

.suggestionBox {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  color: #333;
}

.geBox {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  color: #fff;
  margin-bottom: 48px;
}

.blackBG {
  width: 130px;
  height: 46px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/blackBG.png");
  background-size: 100% 100%;
}

.blackLine {
  width: 500px;
  height: 2px;
  background: #b4b4b4;
  margin: 0 auto;
}

.blackLineBox {
  width: 500px;
  height: 40px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 10px;
}

.selectBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 500px;
  margin: 0 auto;
  position: relative;
  height: 20px;
  justify-content: space-between;
  margin-top: 16px;
}

.selectItem {
  font-size: 22px;
  color: #666;
  /* position: absolute; */
  /* bottom: -16px; */
}

.blackLineItemBox {
  margin: 0 auto;
  height: 20px;
  width: 500px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.blackLineItem {
  width: 2px;
  height: 20px;
  background: #636363;
}

.sexiBox {
  margin: 0 auto;
  width: 528px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/sexiBG.png");
  background-size: 100% 100%;
  position: relative;
  margin-bottom: 28px;
}

.sheBox {
  width: 400px;
  height: 64px;
  background: #c5a9ff;
  border-radius: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin: 0 auto;
}

.banBox {
  width: 100%;
  height: 1378px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/banBG.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.banItem1 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b1.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.banItem2 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b2.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.banItem3 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b3.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.banItem4 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b4.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.banItem5 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b5.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.banItem6 {
  width: 280px;
  height: 400px;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/b6.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
  box-sizing: border-box;
  padding: 32px;
}

.huaBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 32px;
  color: #333;
  margin-bottom: 72px;
}

.huaOutBox {
  width: 516px;
  height: 272px;
  background: #ffffff;
  border-radius: 16px;
  border: 2px solid #e4e7ed;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
}

.huaLine {
  width: 150px;
  height: 12px;
  background: #fff7f6;
  border-radius: 16px;
  margin-top: 10px;
}

.huaItem {
  width: 80px;
  height: 80px;
  border-radius: 40px;
}

.bodyBox {
  width: 222px;
  height: 526px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/nvren.png");
  background-size: 100% 100%;
  margin-bottom: 94px;
}

.bodyBoxN {
  width: 222px;
  height: 526px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/nanren.png");
  background-size: 100% 100%;
  margin-bottom: 94px;
}

.zhiItemR {
  width: 142px;
  height: 58px;
  background: rgba(248, 230, 194, 0.3);
  border-radius: 16px;
  border: 2px solid #fcc350;
  box-sizing: border-box;
  font-size: 24px;
  color: #333;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.zhiItemL {
  width: 142px;
  height: 58px;
  background: rgba(248, 230, 194, 0.3);
  border-radius: 16px;
  border: 2px solid #fcc350;
  box-sizing: border-box;
  font-size: 24px;
  color: #333;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.zhiline {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: -96px;
  top: 20px;
}

.zhilineL {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 132px;
  top: 20px;
}

.zlineL {
  width: 96px;
  height: 2px;
  background: #fcc350;
}

.zline {
  width: 96px;
  height: 2px;
  background: #fcc350;
}

.zQuan {
  width: 12px;
  height: 12px;
  background: #fcc350;
  border-radius: 50%;
}

.xingBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 30px;
  color: #333;
  justify-content: center;
  margin-bottom: 30px;
}

.selectX {
  width: 148px;
  height: 62px;
  background: #b18dfe;
  border-radius: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin-top: 16px;
}

.xingRBox {
  width: 210px;
  height: 484px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
  margin-bottom: 32px;
}

.xingTextBG {
  width: 576px;
  height: 276px;
  margin: 0 auto;
  position: relative;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/xingBGBox.png");
  background-size: 100% 100%;
}

.xingText {
  box-sizing: border-box;
  padding: 64px 70px 0 40px;
  font-size: 24px;
  color: #333;
  height: 276px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
}

.huiTitle {
  width: 400px;
  height: 62px;
  background: #665b7d;
  border-radius: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 48px;
}

.colorList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 12px;
}

.colorLineItem {
  width: 48px;
  height: 198px;
}

.nvBan {
  width: 186px;
  height: 372px;
  margin-right: 48px;
}

.daItemList {
  display: flex;
  flex-direction: column;
  flex-basis: 33.3%;
}

.daItem {
  width: 72px;
  height: 72px;
  border-radius: 36px;
  position: relative;
}

.yuan {
  width: 16px;
  height: 16px;
  background: #333333;
  border-radius: 50%;
  margin-right: 12px;
}

.daListBox {
  width: 646px;
  background: #f5f6fa;
  border-radius: 12px;
  margin: 20px auto;
  font-size: 23px;
  color: #333;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 40px 20px;
}

.fengStyle {
  width: 606px;
  height: 919px;
}

.gouIcon {
  width: 40px;
  height: 40px;
  margin-left: 8px;
}

.kuanBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  margin-top: 58px;
  align-items: center;
  margin-bottom: 128px;
}

.kuanItemOne {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #fff;
  background-size: 100% 100%;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/k1.png");
  margin-right: 36px;
  overflow: hidden;
}

.kuanItemTwo {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #fff;
  background-size: 100% 100%;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/k2.png");
  margin-bottom: 36px;
  overflow: hidden;
}

.kuanItemThree {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #fff;
  background-size: 100% 100%;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/k3.png");
  overflow: hidden;
}

.xianImg {
  width: 204px;
  height: 212px;
}

.contentText {
  width: 622px;
  background: #ffeaf4;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 24px;
  font-size: 32px;
  color: #333;
  margin-top: 16px;
  margin-bottom: 48px;
}

.zaoTitle {
  width: 288px;
  height: 58px;
  background-size: 100% 100%;
  background-image: url("https://mp.yijugongshe.com/upload/baogao/zaoTitle.png");
}

.zaoLine {
  width: 372px;
  height: 4px;
  background: #333;
  margin-top: 20px;
  position: relative;
  left: -24px;
  margin-bottom: 40px;
}

.redBox {
  width: 610px;
  height: 72px;
  background: #94001a;
  position: relative;
  left: -24px;
  margin-bottom: 64px;
}

.recordBox {
  width: 578px;
  margin-left: 58px;
  border-left: 2px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 76px;
  margin-bottom: 20px;
}

.recordImgList {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0 22px;
}

.recordImg {
  width: 216px;
  height: 288px;
  margin-bottom: 12px;
}

.recordOutBox {
  position: relative;
  min-height: 142px;
}

.recordTitle {
  width: 120px;
  height: 142px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #333;
  position: absolute;
  top: 0;
  left: -135px;
}

.guiBox {
  display: flex;
  flex-wrap: wrap;
}

.guiItem {
  display: flex;
  flex-basis: 50%;
  margin-bottom: 20px;
}

.w-b-wrap {
  width: 600px;
  height: 490px;
  display: flex;
}

.w-b_left {
  width: 192px;
  height: 490px;
}

.w-b_right {
  width: 408px;
  height: 490px;
  background-image: url("https://mp.yijugongshe.com/upload/backgroundimg/w-b_right_v3 .jpg");
  background-size: 100% 100%;
  position: relative;
}

.w-b__circle {
  width: 100px;
  height: 100px;
  /* width: 4px;
    height: 4px; */
  border-radius: 50px;
  box-sizing: border-box;
  border: 4px solid #ee0a24;
  position: absolute;
}

.no-click {
  pointer-events: none;
}
</style>
